import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function OskarLogo() {
  return (
    <div style={{ textAlign: "center", marginBottom: 32 }}>
      <Link to="/" style={{ display: "inline-block", lineHeight: 0 }}>
        <img
          src="/oskar_india_tango_logo.png"
          alt="Oskar India Tango"
          style={{ height: 80, width: "auto", display: "inline-block" }}
        />
      </Link>
    </div>
  );
}

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      let data = null;
      try { data = await res.json(); } catch { }
      if (!res.ok) throw new Error(data?.detail || data?.message || `Login failed (HTTP ${res.status})`);
      if (!data?.user || !data?.access_token) throw new Error("Malformed login response");
      login(data);
      if (data.companies?.length > 1 && !data.active_company) {
        navigate("/select-company", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    } catch (e) {
      setError(e.message || "Network error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#1e3a5f",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: "24px 16px",
    }}>
      <div style={{ width: "100%", maxWidth: 380 }}>
        <OskarLogo />

        <div style={{
          background: "white", borderRadius: 16,
          padding: "32px 28px", boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        }}>
          <h1 style={{ fontSize: 18, fontWeight: 500, color: "#1e3a5f", margin: "0 0 6px" }}>Sign in</h1>
          <p style={{ fontSize: 13, color: "#6b8cae", margin: "0 0 24px" }}>Enter your credentials to continue</p>

          {error && (
            <div style={{
              background: "#fff5f5", border: "1px solid #fed7d7",
              borderRadius: 8, padding: "10px 14px", marginBottom: 16,
              fontSize: 13, color: "#c0392b",
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div>
              <label style={{ fontSize: 12, fontWeight: 500, color: "#4a6a8a", display: "block", marginBottom: 5 }}>Email</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                required placeholder="you@example.com" autoComplete="username"
                style={{
                  width: "100%", boxSizing: "border-box",
                  padding: "10px 12px", fontSize: 14,
                  border: "1px solid #d0dcea", borderRadius: 8,
                  outline: "none", color: "#1e3a5f",
                }}
                onFocus={e => e.target.style.borderColor = "#1e3a5f"}
                onBlur={e => e.target.style.borderColor = "#d0dcea"}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, fontWeight: 500, color: "#4a6a8a", display: "block", marginBottom: 5 }}>Password</label>
              <input
                type="password" value={password} onChange={e => setPassword(e.target.value)}
                required placeholder="••••••••" autoComplete="current-password"
                style={{
                  width: "100%", boxSizing: "border-box",
                  padding: "10px 12px", fontSize: 14,
                  border: "1px solid #d0dcea", borderRadius: 8,
                  outline: "none", color: "#1e3a5f",
                }}
                onFocus={e => e.target.style.borderColor = "#1e3a5f"}
                onBlur={e => e.target.style.borderColor = "#d0dcea"}
              />
            </div>

            <button
              type="submit" disabled={loading}
              style={{
                marginTop: 8, padding: "11px 0",
                background: loading ? "#6b8cae" : "#1e3a5f",
                color: "white", border: "none", borderRadius: 8,
                fontSize: 14, fontWeight: 500, cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.15s",
              }}
            >
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>

          {/* Divider */}
          <div style={{ margin: "20px 0", borderTop: "1px solid #e8eef5" }} />

          {/* Registration CTA */}
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 13, color: "#4a6a8a", marginBottom: 10 }}>
              No account yet?
            </div>
            <Link
              to="/register"
              style={{
                display: "block", textAlign: "center",
                background: "#e8f0fa", color: "#1e3a5f",
                borderRadius: 8, padding: "10px 0",
                fontSize: 14, fontWeight: 500, textDecoration: "none",
              }}
            >
              Start free trial
            </Link>
            <p style={{ fontSize: 11, color: "#94afc9", marginTop: 10, lineHeight: 1.6 }}>
              14 days free · no credit card required ·{" "}
              <a href="/plans" style={{ color: "#6b8cae" }}>see plans</a>
            </p>
          </div>

          {/* Back link */}
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Link to="/" style={{ fontSize: 12, color: "#b0c4d8", textDecoration: "none" }}>
              ← Back to homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}